import React from 'react'
import { getMessage } from '../../../utils/index'
import { Card } from 'primereact/card'
import LtsInputText from '../../../components/lottus/lts-input-text'
import LtsDropdownFormaPagamento from '../../../components/lottus/lts-dropdown-forma-pagamento'
import { Divider } from 'primereact/divider'
import BandeiraTaxa from './bandeira-taxa'
import { Button } from 'primereact/button'
import { icons } from '../../../constants'
import LtsInputNumber from '../../../components/lottus/lts-input-number'
import LtsCurrency from '../../../components/lottus/lts-currency'
import LtsDropdownUnidade from '../../../components/lottus/lts-dropdown-unidade'
import { Checkbox } from 'primereact/checkbox'

export const BandeiraForm = (props) => {
  const record = props.record
  const taxa = props.taxa
  const messages = props.messages

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card title={getMessage(messages, 'bandeira.label.bandeira') + ' ' + record.oid || ''}>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsDropdownUnidade
                name={'unidade'}
                label={'Unidade'}
                value={props.record.unidade}
                onChange={(e) => props.setField('unidade', e)}
                showOptionAll={true}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={record.cartao}
                onChange={(e) => props.setField('cartao', e)}
                name={'cartao'}
                label={getMessage(messages, 'bandeira.label.cartao')}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={record.codigo}
                onChange={(e) => props.setField('codigo', e)}
                name={'codigo'}
                label={getMessage(messages, 'bandeira.label.codigo')}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsDropdownFormaPagamento
                value={record.formaPagamento}
                onChange={(e) => props.setField('formaPagamento', e)}
                name={'formaPagamento'}
                label={getMessage(messages, 'bandeira.label.formaPagamento')}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-3 p-md-2 p-lg-2 p-xl-1">
              <Checkbox
                checked={record.ativo}
                onChange={(e) => props.setField('ativo', e.checked)}
                name="ativo"
                style={{ marginRight: '5px' }}
              />
              <label htmlFor="chkativo">{getMessage(messages, 'bandeira.label.ativo')}</label>
            </div>
          </div>
          <Card title={getMessage(messages, 'bandeira.label.taxas')}>
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-4 p-md-3 p-lg-3 p-xl-3">
                <LtsInputNumber
                  value={taxa.parcelaInicial}
                  onChange={(e) => props.setTaxa('parcelaInicial', e)}
                  name={'parcelaInicial'}
                  label={getMessage(messages, 'bandeira.label.parcelaInicial')}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-4 p-md-3 p-lg-3 p-xl-3">
                <LtsInputNumber
                  value={taxa.parcelaFinal}
                  onChange={(e) => props.setTaxa('parcelaFinal', e)}
                  name={'parcelaFinal'}
                  label={getMessage(messages, 'bandeira.label.parcelaFinal')}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-4 p-md-3 p-lg-3 p-xl-3">
                <LtsCurrency
                  value={taxa.taxa}
                  mode={'decimal'}
                  maxFracionDigits={2}
                  name={'taxa'}
                  label={getMessage(messages, 'bandeira.label.percentualTaxa')}
                  onChange={(e) => props.setTaxa('taxa', e)}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-4 p-md-3 p-lg-3 p-xl-3">
                <LtsInputNumber
                  value={taxa.diasCredito}
                  onChange={(e) => props.setTaxa('diasCredito', e)}
                  name={'diasCredito'}
                  label={getMessage(messages, 'bandeira.label.diasCredito')}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-4 p-md-3 p-lg-3 p-xl-3">
                <Button
                  onClick={(e) => props.addTaxa(taxa)}
                  label={getMessage(props.messages, 'bandeira.label.incluirTaxa')}
                  icon={icons.PLUS_ICON}
                  className="p-button-success"
                />{' '}
              </div>
            </div>
            <Divider />
            <BandeiraTaxa
              values={record.taxas}
              messages={props.messages}
              onClickRemoveTaxa={props.onClickRemoveTaxa}
            ></BandeiraTaxa>
          </Card>
        </Card>
      </div>
    </div>
  )
}
